import { render, staticRenderFns } from "./editBanner.vue?vue&type=template&id=12335634&"
import script from "./editBanner.vue?vue&type=script&lang=js&"
export * from "./editBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports